<!-- HelpUsGrow.vue -->
<template>
  <Container
    class="flex flex-col items-center justify-center text-center py-20 px-6"
    style="background-color: #DDEAF5;"
  >
    <!-- Heading -->
    <h2
      class="mb-4"
      style="
        font-family: 'Outfit', sans-serif;
        font-size: 40px;
        font-weight: 700;
        color: #3B5EA6;
        line-height: 1.2;
      "
    >
      Help us Grow Our Impact
    </h2>

    <!-- Subtext -->
    <p
      class="mb-10"
      style="
        font-family: 'Outfit', sans-serif;
        font-size: 18px;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 1.5;
        max-width: 600px;
      "
    >
      Join us in scaling free climate education for more classrooms and a better planet.
    </p>

    <!-- Buttons -->
    <div class="flex flex-wrap items-center justify-center gap-5">
      <a
        :href="buttonOneLink"
        class="btn"
        :style="{ backgroundColor: buttonOneColor }"
      >
        {{ buttonOneText }}
      </a>
      <a
        :href="buttonTwoLink"
        class="btn"
        :style="{ backgroundColor: buttonTwoColor }"
      >
        {{ buttonTwoText }}
      </a>
    </div>
  </Container>
</template>

<script>
import Container from "../../../../Layouts/Container.vue";

export default {
  components:{Container},
  props: {
    buttonOneText: { type: String, default: 'Support Our Work' },
    buttonOneLink: { type: String, default: '/support' },
    buttonOneColor: { type: String, default: '#5B6FA8' },
    buttonTwoText: { type: String, default: 'Explore Our Free Resources' },
    buttonTwoLink: { type: String, default: '/resources' },
    buttonTwoColor: { type: String, default: '#5B6FA8' },
  },
}
</script>

<style scoped>
.btn {
  display: inline-block;
  font-family: 'Outfit', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: #5B6FA8;
  padding: 14px 28px;
  border-radius: 8px;
  text-decoration: none;
  transition: filter 0.2s ease, transform 0.15s ease;
  white-space: nowrap;
}

.btn:hover {
  filter: brightness(0.85);
  transform: translateY(-1px);
}
</style>
